import { BaseSVGType } from '@/components/common/svg/types/svgTypes.ts';

const UserRejectShape = ({
  width = 36,
  height = 36,
  fillColor = 'none',
  style
}: BaseSVGType) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 25 25"
    fill={fillColor}
    style={style}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.1753 16.2799C11.8649 16.2479 12.4499 16.781 12.4819 17.4706C12.5139 18.1602 11.9808 18.7452 11.2912 18.7772C8.58782 18.9027 6.5754 19.4573 5.15619 20.3417C4.25374 20.9041 3.56153 21.6174 3.07214 22.5H11.2688C11.9592 22.5 12.5188 23.0597 12.5188 23.75C12.5188 24.4403 11.9592 25 11.2688 25H1.25C0.863609 25 0.498942 24.8213 0.262174 24.516C0.0254073 24.2106 -0.0568315 23.8129 0.0393961 23.4387C0.616874 21.193 1.89047 19.4311 3.83395 18.22C5.7425 17.0306 8.22223 16.417 11.1753 16.2799ZM17.5 7.5C17.5 4.73858 15.2614 2.5 12.5 2.5C9.73857 2.5 7.5 4.73858 7.5 7.5C7.5 10.2614 9.73857 12.5 12.5 12.5C15.2614 12.5 17.5 10.2614 17.5 7.5ZM20 7.5C20 11.6421 16.6421 15 12.5 15C8.35786 15 5 11.6421 5 7.5C5 3.35786 8.35786 0 12.5 0C16.6421 0 20 3.35786 20 7.5Z"
      fill="black"
    />
    <path
      d="M22.8661 16.6161C23.3543 16.128 24.1457 16.128 24.6339 16.6161C25.122 17.1043 25.122 17.8957 24.6339 18.3839L22.3928 20.625L24.6339 22.8661C25.122 23.3543 25.122 24.1457 24.6339 24.6339C24.1457 25.122 23.3543 25.122 22.8661 24.6339L20.625 22.3928L18.3839 24.6339C17.8957 25.122 17.1043 25.122 16.6161 24.6339C16.128 24.1457 16.128 23.3543 16.6161 22.8661L18.8572 20.625L16.6161 18.3839C16.128 17.8957 16.128 17.1043 16.6161 16.6161C17.1043 16.128 17.8957 16.128 18.3839 16.6161L20.625 18.8572L22.8661 16.6161Z"
      fill="black"
    />
  </svg>
);

export default UserRejectShape;
